import { classNames } from '../utils/style';

export const container = classNames(
  'mx-16 sm:px-0 sm:max-w-719',
  'md:px-0 md:mx-auto md:max-w-736',
  'lg:max-w-1000 xl:max-w-[1202px]',
);
export const featureContainer = classNames(
  'mx-16 md:mx-24',
  'xl:max-w-[1248px] xl:mx-auto',
);
